/**
 * Recipient journey, Part 7: Stage 4, the people in her life.
 *
 * Small pure pieces the room uses:
 *  - the Mystic's closing turn after You & <sender>: the line from the server,
 *    a link for each person she named in her own words, and "Someone else"
 *    (R7.3);
 *  - her reading for one of them: the end of it is one chip, "Send it to Mom"
 *    (R7.5), the other end-of-reading choices wait;
 *  - the password moment at her first send (R7.11), the only one in the
 *    journey: "Set a password so this place stays yours." with "Not now".
 */

export const SOMEONE_ELSE = 'Someone else'
/** Asked when her line after "Someone else" named nobody (Part 11: ends with one question). */
export const WHO_ASK = 'Who would you like to sit with, by name or by who they are to you?'

/** R7.11: the words of the one password moment. */
export const PASSWORD_ASK = 'Set a password so this place stays yours.'
export const PASSWORD_NOT_NOW = 'Not now'
export const PASSWORD_EMAIL_HELP = "We'll send one link to confirm it. Your password works once you tap it."

/** R7.5: the one chip at the end of her reading for someone. */
export function sendItLabel (name = '') {
  return `Send it to ${(name || '').trim() || 'them'}`
}

/** R7.5: at the end of her reading for someone there is one choice, the send. */
export function peopleReadingActions (actions = []) {
  return (actions || []).filter((a) => a && a.action_type === 'share_reading')
}

/** The closing turn's people as links, at most three, then "Someone else". */
export function peopleLinks (turn) {
  const people = ((turn && turn.people) || []).filter((p) => p && p.for_name).slice(0, 3)
  return [
    ...people.map((p) => ({ label: p.label || p.for_name, person: p })),
    { label: (turn && turn.someone_else) || SOMEONE_ELSE, someoneElse: true },
  ]
}

/** R7.11: what the send screen asks before it sends. */
export function passwordStep (moment) {
  const m = moment || {}
  return { ask: !!m.ask, email: !!(m.ask && m.email) }
}
